import styled, { css } from "styled-components";
import { getDirection } from "../../../../../../common-deprecated/themes/common";

const priceStyles = css`
    --_price-font-family: var(--font-semi-bold);
    --_price-text-color: var(--color-midnight);
    --_price-font-size: 1.6rem;

    font-size: var(--_price-font-size);
    line-height: 2rem;
    color: var(--_text-color);
`;

export const Monthly = styled.div`
    ${priceStyles};
    /* stylelint-disable-next-line order/order */
    --_price-font-family: var(--font-regular);
    --_price-font-size: 1.3rem;

    display: flex;
`;

export const MonthlyPriceDisclaimer = styled.button`
    display: flex;
    align-items: center;
    padding: 0;
    background: transparent;
    border: none;
`;

export const DisclaimerIconPlaceholder = styled.span`
    align-self: flex-start;

    /* Override info icon color in Popover */
    svg {
        color: var(--color-platinum-dark);
    }
`;

export const DisclaimerWrapper = styled.div<{ spacingTop?: boolean }>`
    display: flex;
    flex-direction: row;

    ${({ spacingTop }) =>
        spacingTop &&
        css`
            &:not(:empty) {
                margin-top: calc(var(--spacing-1) / 2);
            }
        `};
`;

export const MultiplePrices = styled.div`
    & > div {
        display: flex;
        flex-direction: column;

        &:not(:nth-last-child(1)):not(:only-child) {
            margin-bottom: calc(var(--spacing-1) / 2);
        }

        & > div {
            display: flex;
            justify-content: space-between;
        }
    }
`;

export const MonthlyWrapper = styled.div<{ inBasketDetailsModal?: boolean; isPlaceholder?: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: calc(var(--spacing-1) / 2);
    width: 100%;
    margin-top: calc(var(--spacing-3) / 2);
    filter: ${({ isPlaceholder }) => (isPlaceholder ? "blur(0.25rem)" : "none")};
    transition: filter 0.3s ease-in-out;
    
    ${({ inBasketDetailsModal }) =>
        inBasketDetailsModal &&
        css`
            justify-content: space-between;
            width: 100%;
            margin-top: 0;
        `};

    span:nth-child(even) {
        margin-inline-start: auto;
        text-align: end;
        text-transform: none;

        @supports not (padding-inline: 0) {
            margin-${getDirection("left")}: auto;
        }
    }

`;

export const LegalText = styled.p`
    ${priceStyles};
    /* stylelint-disable-next-line order/order */
    --_price-font-size: 1.4rem;
    --_price-color-text: var(--color-platinum-dark);
    margin: var(--spacing-1) 0 0;
`;
